  import React, { useState, useEffect } from "react";
  import axios from "axios";
  import {
    Card,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TablePagination,
    TableRow,
    Paper,
    Button,
    TableHead,
    IconButton,
    Switch,
    Snackbar,
    Alert,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
  } from "@mui/material";
  import { Link } from "react-router-dom";
  import AddIcon from "@mui/icons-material/Add";
  import EditIcon from "@mui/icons-material/Edit";
  import DeleteIcon from "@mui/icons-material/Delete";
  import VisibilityIcon from "@mui/icons-material/Visibility";
  import { API_ENDPOINTS } from "../../../config/api";
  import { useAuth } from "../../../context/AuthContext";

  const API_URL = API_ENDPOINTS.BRANDS;

  const BrandsListContent = () => {
    const [brands, setBrands] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { user } = useAuth();
    const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      severity: "success", // 'success' | 'error'
    });
    const [deleteDialog, setDeleteDialog] = useState({
      open: false,
      id: null,
    });

    useEffect(() => {
      fetchProducts();
    }, []);

    const fetchProducts = async () => {
      try {
        const response = await axios.get(API_URL.BASE);
        console.log(response);
        setBrands(response.data.brands || []);
      } catch (error) {
        console.error("Error fetching products:", error);
        setBrands([]);
      }
    };

    const handleSnackbarClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setSnackbar((prev) => ({ ...prev, open: false }));
    };

    const handleDeleteClick = (id) => {
      setDeleteDialog({ open: true, id });
    };

    const handleDeleteConfirm = async () => {
      const id = deleteDialog.id;
      setDeleteDialog({ open: false, id: null });
      try {
        await axios.delete(API_URL.DELETE(id));
        setBrands((prevBrands) => prevBrands.filter((brand) => brand.id !== id));
        setSnackbar({
          open: true,
          message: "Brand deleted successfully!",
          severity: "success",
        });
      } catch (error) {
        let userMessage = "Failed to delete brand.";
        if (
          error.response?.data?.message &&
          error.response.data.message.includes("foreign key constraint fails")
        ) {
          userMessage =
            "Cannot delete this brand because it is assigned to other records. Please reassign or remove those records first.";
        }
        setSnackbar({
          open: true,
          message: userMessage,
          severity: "error",
        });
      }
    };

    const handleDeleteCancel = () => {
      setDeleteDialog({ open: false, id: null });
    };

    const handleTogglePublish = async (id, currentStatus) => {
      try {
        await axios.put(API_URL.EDIT(id), { publish: !currentStatus });
        setBrands((prevBrands) =>
          prevBrands.map((brand) =>
            brand.id === id ? { ...brand, publish: !currentStatus } : brand
          )
        );
      } catch (error) {
        console.error("Error updating publish status:", error);
      }
    };
    

    const filteredBrands = Array.isArray(brands)
    ? brands.filter((brand) =>
        brand.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

    return (
      <Card sx={{ boxShadow: "none", borderRadius: "7px", mb: "25px", padding: "25px" }}>
        {/* <NavList /> */}
        <Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: "25px" }}>
            <input
              type="text"
              placeholder="Search brand..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ padding: "8px", width: "200px", borderRadius: "5px", border: "1px solid #ccc" }}
            />
            {user.permissions.includes("add-brands") && (
              <Link to="/ecommerce/create-brand">
                <Button variant="outlined" color="primary">
                  <AddIcon /> Add New Brand
                </Button>
              </Link>
            )}
          </Box>

          <TableContainer className="custom-table" component={Paper}>
            <Table sx={{ minWidth: 1000 }} aria-label="Products Table">
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Logo</TableCell>
                  <TableCell>Publish</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredBrands
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((brand, index) => (
                    <TableRow key={brand.id}>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>{brand.name}</TableCell>
                      <TableCell>
                        <img
                          src={brand.logo}
                          alt={brand.name}
                          style={{ width: "75px", height: "75px", objectFit: "cover" }}
                        />
                      </TableCell>
                      <TableCell>
                        <Switch
                          checked={brand.publish}
                          onChange={() => handleTogglePublish(brand.id, brand.publish)}
                          color="success"
                        />
                      </TableCell>
                      <TableCell>
                        {/* {user.permissions.includes("view-brands") && (
                          <Link to={`/ecommerce/brands-list/details/${brand.id}`}>
                            <IconButton color="info">
                              <VisibilityIcon />
                            </IconButton>
                          </Link>
                        )} */}
                        {user.permissions.includes("edit-brands") && (
                          <Link to={`/ecommerce/edit-brand/${brand.id}`}>
                            <IconButton color="primary">
                              <EditIcon />
                            </IconButton>
                          </Link>
                        )}
                        {user.permissions.includes("delete-brands") && (
                          <IconButton color="error" onClick={() => handleDeleteClick(brand.id)}>
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                    count={filteredBrands.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(event, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(event) => {
                      setRowsPerPage(parseInt(event.target.value, 10));
                      setPage(0);
                    }}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Box>
        <Dialog
          open={deleteDialog.open}
          onClose={handleDeleteCancel}
        >
          <DialogTitle>Delete Brand</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this brand?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCancel} color="primary" variant="text" sx={{ fontWeight: 600 }}>
              Cancel
            </Button>
            <Button onClick={handleDeleteConfirm} color="error" variant="text" sx={{ fontWeight: 600 }}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={1500}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Card>
    );
  };

  export default BrandsListContent;
